itsoftApp.createModule("insertMap", function () {
    var APIKEY = "d4d7994c-465c-4f96-bf4c-aabe2b09d8ca";
    var LANG = "ru_RU";
    // var parents = document.querySelectorAll(".js-map");
    var module = this;
    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;

    var initQueue = function() {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module insertMap] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };

    var loadAndInit = function() {
        var f = function() {
            libraryLoaded = true;
            initQueue();
        };

        if (typeof ymaps !== "undefined") {
            f();

        } else {
            itsoftApp.loadScript("https://api-maps.yandex.ru/2.1?apikey=" + APIKEY + "&load=package.full&lang=" + LANG, f);
        }
    };

    var addEvent = function(func) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {
            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };

    var initMapSection = function (mapSection, mapInfoSection) {
        // if (!parents.length) {
        //     return false;
        // }
        
        var emailText = "Email: ";
        var telText = "Тел.:"

        var init = function () {
            var create = function (data) {
                // Array.prototype.forEach.call(parents, function(value, index) {
                var dataObject = JSON.parse(data);
                var map;

                if (mapSection) {
                    var mapDomElement = mapSection.querySelector(".js-map");
                    var mapCanvas = mapDomElement.querySelector(".map__canvas");
                    var mapId = mapCanvas.id;
                    var mapControls = ["zoomControl"];
                    var dataPinsAttribute = mapCanvas.getAttribute("data-pins");
                    var dataMapSlideAttribute = mapCanvas.getAttribute("data-map-slide");
                    var dataClassAttribute = mapCanvas.getAttribute("data-class");
                    var dataMapAjaxAttribute = mapCanvas.hasAttribute("data-map-ajax");
                    var dataZoomAttribute = mapCanvas.getAttribute("data-zoom");

                    ymaps.ready(function () {
                        if (mapCanvas.hasAttribute("data-route")) {
                            mapControls.push("routePanelControl");
                        }

                        var createPins = function () {
                            var pinsData = dataObject[mapId].pins;
                            if (dataMapSlideAttribute) {
                                var fragment = document.createDocumentFragment();
                                var swiperWrapper = mapInfoSection.querySelector(".swiper-wrapper");
                                var classBlock = dataClassAttribute;
                                var slideClass = classBlock + "__slide";
                            }

                            Array.prototype.forEach.call(pinsData, function (pinData) {
                                var myGeoObject = new ymaps.Placemark(
                                pinData.coord,
                                {},
                                {
                                    // Опции.
                                    // Необходимо указать данный тип макета.
                                    iconLayout: "default#image",
                                    // Своё изображение иконки метки.
                                    iconImageHref: "/media/images/map-pin.png",
                                    // Размеры метки.
                                    iconImageSize: [20, 30],
                                    // Смещение левого верхнего угла иконки относительно
                                    // её "ножки" (точки привязки).
                                    iconImageOffset: [-10, -30]
                                });

                                map.geoObjects.add(myGeoObject);

                                if (dataMapSlideAttribute) {
                                    var nameClass = classBlock + "__name";
                                    var textClass = classBlock + "__contacts-text";
                                    var slideElement = document.createElement("div");
                                    var bElement = document.createElement("b");
                                    var nameElement = document.createElement("p");
                                    var addressElement = document.createElement("p");
                                    var contactsElement = document.createElement("p");
                                    slideElement.classList.add(slideClass);
                                    slideElement.classList.add("swiper-slide");
                                    nameElement.appendChild(bElement);
                                    bElement.innerHTML = pinData.name;
                                    nameElement.classList.add(nameClass);
                                    slideElement.appendChild(nameElement);
                                    addressElement.innerHTML = pinData.address;
                                    addressElement.classList.add(textClass);
                                    slideElement.appendChild(addressElement);
                                    contactsElement.innerHTML = pinData.tel + "<br>" + pinData.email;
                                    contactsElement.classList.add(textClass);
                                    slideElement.appendChild(contactsElement);
                                    fragment.appendChild(slideElement);
                                }

                                myGeoObject.events
                                .add("mouseenter", function (e) {
                                    e.get("target").options.set("iconImageHref", "/media/images/map-pin-active.png");

                                    slideElement.classList.add("hovered");
                                    var swiperContainer = slideElement.closest(".swiper-container");
                                    var slides = swiperContainer.querySelectorAll(".swiper-slide");
                                    var slideIndex;
                                    for (var i = 0; i < slides.length; i++) {
                                        if (slides[i] === slideElement) {
                                            slideIndex = i;
                                        }
                                        // break;
                                    }
                                    swiperContainer.dom7ElementDataStorage.swiper.slideTo(slideIndex);
                                })
                                    
                                .add("mouseleave", function (e) {
                                      e.get("target").options.set("iconImageHref", "/media/images/map-pin.png");
                                      slideElement.classList.remove("hovered");
                                });

                                slideElement.addEventListener("mouseover", function () {
                                    myGeoObject.options.set("iconImageHref", "/media/images/map-pin-active.png");
                                });

                                slideElement.addEventListener("mouseout", function () {
                                    myGeoObject.options.set("iconImageHref", "/media/images/map-pin.png");
                                });
                            });

                            if (fragment) {
                                swiperWrapper.appendChild(fragment);

                                if (mapInfoSection.classList.contains("js-invisible-later")) {
                                    if (mapInfoSection.classList.contains("js-slider")) {
                                        itsoftApp.modules.slidersLibrary.callback(mapInfoSection);
                                    }

                                    mapInfoSection.classList.remove("js-invisible-later");
                                }
                            }
                        }
                        
                        function createMap () {
                            if (dataMapAjaxAttribute) {
                                if (dataObject.hasOwnProperty(mapId)) {
                                    map = new ymaps.Map(mapId, {
                                        center: [dataObject[mapId].lat, dataObject[mapId].lng],
                                        zoom: +dataZoomAttribute || 10,
                                        controls: mapControls
                                    });
                                }
                            } else {
                                var dataPinAttribute = mapCanvas.hasAttribute("data-pin");

                                map = new ymaps.Map(mapId, {
                                    center: [+mapCanvas.getAttribute("data-lat"), +mapCanvas.getAttribute("data-lng")],
                                    zoom: +dataZoomAttribute || 10,
                                    controls: mapControls
                                });

                                if (mapCanvas.hasAttribute("data-route")) {
                                    var control = map.controls.get("routePanelControl");
                                    var fromCoord = [+mapCanvas.getAttribute("data-lat-from"), +mapCanvas.getAttribute("data-lng-from")];
                                    var toCoord = [+mapCanvas.getAttribute("data-lat-to"), +mapCanvas.getAttribute("data-lng-to")];

                                    // Задание состояния для панели маршрутизации.
                                    control.routePanel.state.set({
                                        // Адрес начальной точки.
                                        from: fromCoord,
                                        // Адрес конечной точки.
                                        to: toCoord
                                    });
                                }

                                if (dataPinAttribute) {
                                    var myGeoObject = new ymaps.Placemark(
                                        [+mapCanvas.getAttribute("data-lat"), +mapCanvas.getAttribute("data-lng")],
                                        {},
                                        {
                                            // Опции.
                                            // Необходимо указать данный тип макета.
                                            iconLayout: "default#image",
                                            // Своё изображение иконки метки.
                                            iconImageHref: "/media/images/map-pin.png",
                                            // Размеры метки.
                                            iconImageSize: [20, 30],
                                            // Смещение левого верхнего угла иконки относительно
                                            // её "ножки" (точки привязки).
                                            iconImageOffset: [-10, -30]
                                        });

                                        map.geoObjects.add(myGeoObject);
                                }
                            }

                            if (dataMapAjaxAttribute && (dataObject.hasOwnProperty(mapId))) {
                                createPins();
                            }
                        }

                        createMap();
                    });
                } else {
                    var pinsData = dataObject["default"].pins;
                    var fragment = document.createDocumentFragment();
                    var swiperWrapper = mapInfoSection.querySelector(".swiper-wrapper");
                    var classBlock = "service-centres";
                    var slideClass = classBlock + "__slide";
                    var nameClass = classBlock + "__name";
                    var textClass = classBlock + "__contacts-text";

                    Array.prototype.forEach.call(pinsData, function (pinData) {
                        var slideElement = document.createElement("div");
                        var bElement = document.createElement("b");
                        var nameElement = document.createElement("p");
                        var addressElement = document.createElement("p");
                        var contactsElement = document.createElement("p");
                        slideElement.classList.add(slideClass);
                        slideElement.classList.add("swiper-slide");
                        nameElement.appendChild(bElement);
                        bElement.innerHTML = pinData.name;
                        nameElement.classList.add(nameClass);
                        slideElement.appendChild(nameElement);
                        addressElement.innerHTML = pinData.address;
                        addressElement.classList.add(textClass);
                        slideElement.appendChild(addressElement);
                        contactsElement.innerHTML = pinData.tel + "<br>" + pinData.email;
                        contactsElement.classList.add(textClass);
                        slideElement.appendChild(contactsElement);
                        fragment.appendChild(slideElement);
                    });

                    if (fragment) {
                        swiperWrapper.appendChild(fragment);

                        if (mapInfoSection.classList.contains("js-invisible-later")) {
                            if (mapInfoSection.classList.contains("js-slider")) {
                                itsoftApp.modules.slidersLibrary.callback(mapInfoSection);
                            }

                            mapInfoSection.classList.remove("js-invisible-later");
                        }
                    }
                }
            }

            var sendRequest = function (onSuccess) {
                var urlData = "/ajax/maps.json";
                if (mapInfoSection) {
                    var dataMapType = mapInfoSection.closest("[data-map-type]");
                    if (dataMapType.getAttribute("data-map-type") === "services") {
                        urlData = "/ajax/maps.json"
                    } else if (dataMapType.getAttribute("data-map-type") === "contacts") {
                        urlData = "/ajax/maps-contacts.json"
                    }
                }
                var xhr = new XMLHttpRequest();

                xhr.addEventListener("load", function () {
                    if (onSuccess) {
                        onSuccess(xhr.response);
                    }
                });

                xhr.open("GET", urlData);
                xhr.send();
                
                // BX.ajax.loadJSON(
                //     url,
                //     data,
                //     onSuccess
                // );
            }

            sendRequest(create);
        }

        addEvent(init);

        DEBUG && console.log("%c--[module map] delegating loadAndInit to pageLoad module", "font-style: italic; color: #999");
    }

    module.callback = function (mapSection, mapInfoSection) {
        console.log("MAP_MAP_MAP")
        initMapSection(mapSection, mapInfoSection);
    }
});
